

import React, { useState, useEffect } from 'react';
import './MembersHistory.css';
import * as Constants from '../../Constant/constant';
import axios from 'axios';
import { useAuth } from '../../Constant/Auth';
import Swal from 'sweetalert2';
import SearchableSelect from '../../shared/SearchableSelect';
function MembersHistory() {
    const [memberType, setMemberType] = useState('');
        const [membersHistoryList, setMembersHistoryList] = useState([]);
        const [loadingMembersHistory, setLoadingMembersHistory] = useState(true);
        const [errorMembersHistory, setErrorMembersHistory] = useState(null);
        const [roleId, setRoleId] = useState(localStorage.getItem('roleId'));
        const [roles, setRoles] = useState([]);
        const [libraries, setLibraries] = useState([]);
        const [currentPage, setCurrentPage] = useState(1);
        const [itemsPerPage] = useState(5);
       
        const [selectedImage, setSelectedImage] = useState(null);
        const [showConfirmation, setShowConfirmation] = useState(false);
        const [memberToToggle, setMemberToToggle] = useState(null);

       
    useEffect(() => {
        fetchMembersHistory();
    }, [memberType]);

    const fetchMembersHistory = async () => {
        setLoadingMembersHistory(true);
        setErrorMembersHistory(null);
      
        try {
          const response = await fetch(`${Constants.API_PATH}/auth_employee_list`);
          if (!response.ok) throw new Error('Failed to fetch members history');
      
          const data = await response.json();
      
          // Client-side filter
          const filteredData = memberType
            ? data.filter((member) => member.role_id === parseInt(memberType))
            : data;
      
          setMembersHistoryList(filteredData);
        } catch (error) {
          setErrorMembersHistory(error.message);
        } finally {
          setLoadingMembersHistory(false);
        }
      };
      
      

      const handleToggleMemberStatus = async (memberId, currentStatus) => {
        const newStatus = currentStatus === 1 ? 0 : 1;
      
        // ✅ Show confirmation popup first
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: `Do you want to ${newStatus === 1 ? 'Activate' : 'Deactivate'} this member?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, Update it!',
          cancelButtonText: 'Cancel'
        });
      
        if (result.isConfirmed) {
          try {
            const response = await fetch(`${Constants.API_PATH}/update_user_status/${memberId}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ status: newStatus }),
            });
      
            if (!response.ok) {
              throw new Error('Failed to update status');
            }
      
            await Swal.fire(
              'Updated!',
              `Member has been ${newStatus === 1 ? 'Activated' : 'Deactivated'} successfully.`,
              'success'
            );
      
            fetchMembersHistory(); // ✅ refresh the list
          } catch (error) {
            console.error('Error updating status:', error);
            Swal.fire('Error', 'Failed to update status: ' + error.message, 'error');
          }
        }
      };
      const confirmToggleMemberStatus = async () => {
              setShowConfirmation(false);
              if (!memberToToggle) return;
      
              const {
                  id: memberId,
                  status: currentStatus
              } = memberToToggle;
              const newStatus = currentStatus === 1 ? 0 : 1;
      
              try {
                  const response = await fetch(`${Constants.API_PATH}/update_user_status/${memberId}`, {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                          status: newStatus
                      }),
                  });
      
                  if (!response.ok) {
                      throw new Error('Failed to update status');
                  }
      
                  fetchMembersHistory(); // refresh the list
              } catch (error) {
                  console.error('Error updating status:', error);
                  alert('Failed to update status: ' + error.message);
              }
          };

          const cancelToggleMemberStatus = () => {
            setShowConfirmation(false);
            setMemberToToggle(null);
        }; 


    useEffect(() => {
        const fetchData = async () => {
            try {
                const rolesResponse = await axios.get(Constants.API_PATH + `/roles_list`);
                const librariesResponse = await axios.get(Constants.API_PATH + `/add_new_library_data`);
                setRoles(rolesResponse.data);
                setLibraries(librariesResponse.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    // const openImagePopup = (imageUrl) => {
    //     setSelectedImage(imageUrl);
    // };

    const openImagePopup = (img) => {
        Swal.fire({
          imageUrl: `https://libtest.jaipuriaschools.com/${img.replace(/\\/g, '/')}`,
          imageAlt: 'Aadhaar Image',
          showCloseButton: true,
          width: '600px'
        });
      };
      

    const closeImagePopup = () => {
        setSelectedImage(null);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = membersHistoryList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(membersHistoryList.length / itemsPerPage);




  // const handleDeleteMember = async (memberId) => {
  //   const confirmDelete = window.confirm("Are you sure you want to delete this member?");
  //   if (!confirmDelete) return;

  //   try {
  //     const response = await fetch(`${Constants.API_PATH}/delete_user/${memberId}`, {
  //       method: 'DELETE',
  //     });

  //     if (!response.ok) {
  //       throw new Error('Failed to delete member');
  //     }

  //     Swal.fire({
  //       icon: 'success',
  //       title: 'Deleted!',
  //       text: 'Member has been deleted successfully.',
  //       timer: 1500,
  //       showConfirmButton: false,
  //     });

  //     fetchMembersHistory(); // Refresh the list
  //   } catch (error) {
  //     console.error('Error deleting member:', error);
  //     alert('Failed to delete member: ' + error.message);
  //   }
  // };




const handleDeleteMember = async (memberId) => {
  try {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });

    if (!confirmResult.isConfirmed) return;

    const response = await fetch(`${Constants.API_PATH}/delete_user/${memberId}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to delete member');
    }

    Swal.fire({
      icon: 'success',
      title: 'Deleted!',
      text: 'Member has been deleted successfully.',
      timer: 1500,
      showConfirmButton: false,
    });

    fetchMembersHistory(); // Refresh the list
  } catch (error) {
    console.error('Error deleting member:', error);
    Swal.fire({
      icon: 'error',
      title: 'Deletion Failed',
      text: error.message || 'Something went wrong.',
    });
  }
};


const URL='https://libtest.jaipuriaschools.com';

//   const handleUpdateMember = async (member) => {
//     const { value: formValues } = await Swal.fire({
//       title: 'Update User',
//       html:
//         `<style>
//   .swal2-popup {
//     max-width: none !important;
//     width: 50vw !important;
//   }
// </style>` +
// `<div style="display: flex; gap: 5px;">` +
//   `<input id="swal-firstname" class="swal2-input" placeholder="First Name" value="${member.first_name}" style="flex: 1;" />` +
//   `<input id="swal-lastname" class="swal2-input" placeholder="Last Name" value="${member.last_name}" style="flex: 1;" />` +
// `</div>` +
// `<div style="display: flex; gap: 5px;">` +
//   `<input id="swal-email" class="swal2-input" placeholder="Email" value="${member.email}" style="flex: 1;" />` +
//   `<input id="swal-mobile" class="swal2-input" placeholder="Mobile No" value="${member.mobile_no}" style="flex: 1;" />` +
// `</div>` +
// `<div style="text-align: center; margin: 10px auto;">` +
//   `<label>Existing Aadhaar Image:</label><br/>` +
//   `<img id="aadhaar-preview" src="${URL}/${member.aadhaar_img}" style="max-width: 100%; max-height: 150px; border: 1px solid #ccc; margin:0 auto;" />` +
// `</div>` +

// `<div style="text-align: center; margin: 10px auto;">` +
//   `<label>Existing User Image:</label><br/>` +
//   `<img id="user-preview" src="${URL}/${member.user_img}" style="max-width: 100%; max-height: 150px; border: 1px solid #ccc; margin:0 auto;" />` +
// `</div>` +

// `<div style="margin-top: 10px;">` +
//   `<label for="swal-image">Upload New Aadhaar Image:</label><br/>` +
//   `<input id="swal-image" type="file" accept="image/*" />` +
// `</div>` +
// `<div style="margin-top: 10px;">` +
//   `<label for="swal-user-image">Upload New User Image:</label><br/>` +
//   `<input id="swal-user-image" type="file" accept="image/*" />` +
// `</div>`,
//       focusConfirm: false,
//       showCancelButton: true,
//       preConfirm: () => {
//         return {
//           first_name: document.getElementById('swal-firstname').value,
//           last_name: document.getElementById('swal-lastname').value,
//           email: document.getElementById('swal-email').value,
//           mobile_no: document.getElementById('swal-mobile').value,
//         };
//       }
//     });

//     if (formValues) {
//       try {
//         const response = await fetch(`${Constants.API_PATH}/update_user/${member.id}`, {
//           method: 'PUT',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(formValues),
//         });

//         if (!response.ok) throw new Error('Update failed');


//         Swal.fire({
//           icon: 'success',
//           title: 'Updated!',
//           text: 'User updated successfully',
//           timer: 1500,
//           showConfirmButton: false,
//         });

//         fetchMembersHistory(); // Refresh data
//       } catch (err) {
//         console.error(err);
//         Swal.fire('Error', 'Something went wrong', 'error');
//       }
//     }
//   };



const handleUpdateMember = async (member) => {
  const { value: formValues } = await Swal.fire({
    title: 'Update User',
    html:
      `<style>
.swal2-popup {
  max-width: none !important;
  width: 50vw !important;
}
</style>` +
      `<div style="display: flex; gap: 5px;">` +
      `<input id="swal-firstname" class="swal2-input" placeholder="First Name" value="${member.first_name}" style="flex: 1;" />` +
      `<input id="swal-lastname" class="swal2-input" placeholder="Last Name" value="${member.last_name}" style="flex: 1;" />` +
      `</div>` +
      `<div style="display: flex; gap: 5px;">` +
      `<input id="swal-email" class="swal2-input" placeholder="Email" value="${member.email}" style="flex: 1;" />` +
      `<input id="swal-mobile" class="swal2-input" placeholder="Mobile No" value="${member.mobile_no}" style="flex: 1;" />` +
      `</div>` +
      `<div style="text-align: center; margin: 10px auto;">` +
      `<label>Existing Aadhaar Image:</label><br/>` +
      `<img id="aadhaar-preview" src="${URL}/${member.aadhaar_img}" style="max-width: 100%; max-height: 150px; border: 1px solid #ccc; margin:0 auto;" />` +
      `</div>` +
      `<div style="text-align: center; margin: 10px auto;">` +
      `<label>Existing User Image:</label><br/>` +
      `<img id="user-preview" src="${URL}/${member.user_img}" style="max-width: 100%; max-height: 150px; border: 1px solid #ccc; margin:0 auto;" />` +
      `</div>` +
      `<div style="margin-top: 10px;">` +
      `<label for="swal-image">Upload New Aadhaar Image:</label><br/>` +
      `<input id="swal-image" type="file" accept="image/*" />` +
      `</div>` +
      `<div style="margin-top: 10px;">` +
      `<label for="swal-user-image">Upload New User Image:</label><br/>` +
      `<input id="swal-user-image" type="file" accept="image/*" />` +
      `</div>`,
    focusConfirm: false,
    showCancelButton: true,
    preConfirm: () => {
      return {
        first_name: document.getElementById('swal-firstname').value,
        last_name: document.getElementById('swal-lastname').value,
        email: document.getElementById('swal-email').value,
        mobile_no: document.getElementById('swal-mobile').value,
        aadhaar_img: document.getElementById('swal-image').files[0] || null,
        user_img: document.getElementById('swal-user-image').files[0] || null,
      };
    }
  });

  if (formValues) {
    try {
      const formData = new FormData();
      formData.append('first_name', formValues.first_name);
      formData.append('last_name', formValues.last_name);
      formData.append('email', formValues.email);
      formData.append('mobile_no', formValues.mobile_no);

      // Only append if a new file is selected
      if (formValues.aadhaar_img) {
        formData.append('aadhaar_img', formValues.aadhaar_img);
      }
      if (formValues.user_img) {
        formData.append('user_img', formValues.user_img);
      }

      const response = await fetch(`${Constants.API_PATH}/update_user/${member.id}`, {
        method: 'PUT',
        body: formData,
      });

      if (!response.ok) throw new Error('Update failed');

      Swal.fire({
        icon: 'success',
        title: 'Updated!',
        text: 'User updated successfully',
        timer: 1500,
        showConfirmButton: false,
      });

      fetchMembersHistory(); // Refresh data
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Something went wrong', 'error');
    }
  }
};





    return (
        <div className="members-history-section containernew">
            {/* <nav className="breadcrumb">
                <a href="#" className="breadcrumb-link">Home</a> /
                <a href="#" className="breadcrumb-link">Library Management</a> /
                <span className="breadcrumb-current">Members History</span>
            </nav> */}
            <h2 className="section-title">Members List</h2>

            <div className="filter-section row">
              <div className="col-md-6 float-right">
                {/* <span><label htmlFor="memberType" className="form-label">Member Type*</label></span> */}
               <span> <SearchableSelect
                    id="memberType"
                    className="form-select"
                    value={memberType}
                    onChange={(e) => setMemberType(e.target.value)}
                    options={roles.map((role) => ({ value: role.id, label: role.name }))}
                    placeholder="Select Role"
                    />
                </span>
                    </div>
            <div className="col-md-6 ms-auto">
                    

                <button className="search-button" onClick={fetchMembersHistory}>Search History</button>
                </div>

            </div>

            <div className="table-responsive">
                {loadingMembersHistory ? (
                    <p>Loading members history...</p>
                ) : errorMembersHistory ? (
                    <p>{errorMembersHistory}</p>
                ) : (
                    <table className="custom-table">
                        <thead>
                            <tr>
                                <th>Sr.No.</th>
                                <th>Aadhaar Image</th>
                                <th>User Image</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email</th>
                                <th>Role Name</th>
                                <th>Mobile No</th>
                                <th>Library Name</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length === 0 ? (
                                <tr><td colSpan="8">No data available in table</td></tr>
                            ) : (
                                currentItems.map((member, index) => {
                                    const roleName = roles.find(r => r.id === member.role_id)?.name || 'N/A';
                                    const libraryName = libraries.find(l => l.id === member.library_id)?.library_name || 'N/A';
                                    return (
                                        <tr key={member.id}>
                                            <td>{indexOfFirstItem + index + 1}</td>
                                            <td>
                                            {member.aadhaar_img ? (
                                                <img
                                                src={`https://libtest.jaipuriaschools.com/${member.aadhaar_img.replace(/\\/g, '/')}`}
                                                alt="Aadhaar"
                                                className="profile-image"
                                                onClick={() => openImagePopup(member.aadhaar_img)}
                                                style={{ cursor: 'pointer', width: '80px', height: 'auto' }}
                                                />
                                            ) : (
                                                <span>No Aadhaar Image</span>
                                            )}
                                            </td>
                                            <td>
                                              {member.user_img ? (
                                                <img
                                                src={`https://libtest.jaipuriaschools.com/${member.user_img.replace(/\\/g, '/')}`}
                                                alt="User"
                                                className="profile-image"
                                                onClick={() => openImagePopup(member.user_img)}
                                                style={{ cursor: 'pointer', width: '80px', height: 'auto' }}
                                                />
                                            ) : (
                                                <span>No User Image</span>
                                            )}
                                            </td>

                                            <td>{member.first_name}</td>
                                            <td>{member.last_name}</td>
                                            <td>{member.email}</td>
                                            <td>{roleName}</td>
                                            <td>{member.mobile_no}</td>
                                            <td>{libraryName}</td>
                                            <td>{member.status === 0 ? 'Inactive' : 'Active'}</td>
                                            <td>
                                                <button
                                                    onClick={() => handleToggleMemberStatus(member.id, member.status)}
                                                    className={member.status === 1 ? 'inactive-btn' : 'activate-btn'}
                                                >
                                                    {member.status === 1 ? 'Inactivate' : 'Activate'}
                                                </button>

                                                <button
                          className="bg-danger text-white"
                          onClick={() => handleDeleteMember(member.id)}
                        >
                          Delete
                        </button>
                        <button
                          className=""
                          onClick={() => handleUpdateMember(member)}
                        >
                          Update
                        </button>
                                                </td>

                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            <div className="pagination">
                {[...Array(totalPages)].map((_, index) => (
                    <button
                        key={index + 1}
                        onClick={() => setCurrentPage(index + 1)}
                        className={currentPage === index + 1 ? 'active-page' : ''}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>
<br/><br/>
            <button className="export-button" onClick={() => console.log('Exporting...')}>Export Members List</button>
            <br/>
        </div>
    );
}

export default MembersHistory;
